/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2018 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H217483 on 1/18/2019.
 */

import React from 'react'
import {injectIntl} from 'react-intl';
import {Select, Checkbox} from '@scuf/common';

/**
 * Component is a dropdown button with checkbox options. Properties for this component are:
 * -label - Label of the dropdown, displayed at the beginning of the value inside the dropdown
 * -allOptions - array of objects representing all possible options. The items of the array need to have
 *               key and text property.
 * -selectedOptions - list of keys currently selected in the parent component
 * -initSelectedOptions - list of keys selected on first load
 * -onChange - onChange callback, provides list of currently selected
 */
class CheckboxDropdown extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedOptions: (typeof this.props.initSelectedOptions !== 'undefined') ? this.props.initSelectedOptions : [],
        }

        this.onSelect = this.onSelect.bind(this);
    }

    onSelect(option) {
        const { selectedOptions, onChange } = this.props;
        const updatedOptions = selectedOptions.includes(option)
            ? selectedOptions.filter((s) => s !== option)
            : [...selectedOptions, option];

        onChange(updatedOptions);
    }

    render() {
        const { intl, label, allOptions, selectedOptions, className } = this.props;
        const options = allOptions.map((option) => ({
            key: option.key,
            value: option.key,
            content: (
                <div>
                    <Checkbox
                        label={option.text}
                        checked={selectedOptions.includes(option.key)}
                    />
                    {option.icon != null ? option.icon : null}
                </div>
            ),
        }));

        let stateText = label;
        if (selectedOptions.length > 0 && selectedOptions.length !== allOptions.length) {
            stateText += selectedOptions
                .map((s) => allOptions.find((o) => o.key === s).text)
                .join(", ");
        } else {
            stateText += intl.formatMessage({ id: 'filter.all' });
        }

        let dropdownClassName = 'checkbox-dropdown';
        if (className) {
            dropdownClassName += " " + className;
        }

        return (
            <Select
                className={dropdownClassName}
                closeOnChange={false}
                selectOnBlur={false}
                text={stateText}
                fluid
                options={options}
                value={null}
                onChange={this.onSelect}
            />
        );
    }
}

export default injectIntl(CheckboxDropdown);